import React, { ReactNode, useState } from "react";
import { Container } from "./style";

type TooltipProps = {
    message: string;
    hasNotification: boolean;
    direction?: "top" | "left" | "bottom" | "right";
    isActionLink?: boolean;
    link?: string;
    children?: ReactNode;
};

const TooltipClicable = ({ message, isActionLink = false, link, hasNotification, children }: TooltipProps) => {
    const [showTooltip, setShowToolTip] = useState(false);

    return (
        <Container
            showTooltip={showTooltip}
            hasNotification={hasNotification}
            isActionLink={isActionLink}
            onMouseEnter={() => setShowToolTip(true)}
            onMouseLeave={() => setShowToolTip(false)}
        >
            <div className="children">
                {children ? (
                    children
                ) : (
                    <>
                        {hasNotification ? (
                            <img style={{ width: "32px" }} src="/icons/inNotification.svg" alt="chat com notificação" />
                        ) : (
                            <img
                                style={{ width: "24px" }}
                                src="/icons/outNotification.svg"
                                alt="chat sem notificação"
                            />
                        )}
                    </>
                )}
            </div>
            <div className="tooltip-content">
                <div className="msg">
                    {isActionLink ? (
                        <>
                            <a href={link}>
                                <p>{message}</p>
                            </a>
                        </>
                    ) : (
                        <p>{message}</p>
                    )}
                </div>
            </div>
        </Container>
    );
};

export default TooltipClicable;
